import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  content: string;
  initials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  initials
}: TestimonialCardProps) {
  return <div className="bg-white rounded-2xl shadow-lg p-8 relative border border-gray-100 h-full flex flex-col" data-id="element-204">
      <Quote className="absolute top-6 right-6 h-8 w-8 text-blue-100" data-id="element-205" />

      <div className="flex items-center mb-6" data-id="element-206">
        <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-900 font-bold text-lg mr-4 border-2 border-blue-200" data-id="element-207">
          {initials}
        </div>
        <div data-id="element-208">
          <h3 className="font-bold text-gray-900" data-id="element-209">{name}</h3>
          <p className="text-sm text-gray-500" data-id="element-210">{role}</p>
          <p className="text-xs text-blue-900 font-medium" data-id="element-211">{location}</p>
        </div>
      </div>

      <div className="flex mb-4" data-id="element-212">
        {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-213" />)}
      </div>

      <p className="text-gray-700 italic leading-relaxed flex-grow" data-id="element-214">
        "{content}"
      </p>
    </div>;
}